document.addEventListener('DOMContentLoaded', function() {
	// Use CAPTURE phase - runs before other handlers
	document.addEventListener('click', function(e) {
		if (e.target && e.target.id === 'checkoutButton') {
			var checkbox = document.getElementById('cart-agreement-checkbox');
			
			// Check if checkbox exists and is not checked
			if (checkbox && !checkbox.checked) {
				e.stopImmediatePropagation(); // CRITICAL: Stop ALL other handlers
				e.preventDefault(); // Prevent default action
				
				// Add visual feedback - highlight the checkbox area
				var agreement = document.querySelector('.Cart__Agreement');
				if (agreement) {
					agreement.style.border = '2px solid #ff0000';
					agreement.style.borderRadius = '4px';
					agreement.style.padding = '10px';
					agreement.style.backgroundColor = '#ffe6e6';
				}
				
				// Show alert message
				alert('Du skal acceptere betingelserne før du kan fortsætte til checkout.');
				
				// Remove visual feedback after 3 seconds
				setTimeout(function() {
					if (agreement) {
						agreement.style.border = 'none';
						agreement.style.padding = '0';
						agreement.style.backgroundColor = 'transparent';
					}
					e.target.disabled = false;
				}, 3000);
				
				return false;
			}
		}
	}, true); // <- TRUE = CAPTURE PHASE - RUNS FIRST!
	
	// Handle checkbox changes
	document.addEventListener('change', function(e) {
		if (e.target && e.target.id === 'cart-agreement-checkbox') {
			var agreement = document.querySelector('.Cart__Agreement');
			if (agreement) {
				agreement.style.border = 'none';
				agreement.style.padding = '0';
				agreement.style.backgroundColor = 'transparent';
			}
		}
	});
});